module.exports = __webpack_public_path__ + "static/media/avatar-2.c9ab07da.jpg";